import r from"styled-components";import{theme as o}from"../../../theme.js";const e=r.div`
  display: flex;
  margin-left: ${o.spacing*2}px;
  > div {
    border: 1px solid ${o.colors.gray[50]};
    border-radius: 50%;
    margin-left: ${o.spacing*-2}px;
  }
`,i=r.div`
  background-color: ${o.colors.secondary[900]};
  font-size: 12px;
  color: ${o.colors.shades[0]};
  width: 24px;
  height: 24px;
  border-radius: 50%;
  line-height: 22px;
  text-align: center;
  font-weight: 700;
`;export{e as Container,i as ShowMore};
